<template>
  <form :action="url" @submit.prevent id="MonsterSearch" method="GET">
    <div
      class="border-t border-bg-lightest bg-tint-less relative z-1 tint:focus-within:hover sm:font-light"
    >
      <base-field
        autofocus
        placeholder="Search monster templates…"
        class="py-4 px-3 max-md:pl-2"
        name="term"
        v-model="term"
        data-test="monsterSearchField"
      />
    </div>

    <div class="pt-px text-sm flex items-stretch relative">
      <div class="whitespace-no-wrap flex-1 ">
        <label for="monsterType" class="u-visually-hidden">Type:</label>
        <base-select
          :display-filter="startCase"
          default-option="Monster type"
          title="Monster type"
          :collection="monsterTypes"
          :selected-if="matchesCurrent(type)"
          name="type"
          v-model="type"
          data-test="monsterTypeSelect"
        />
      </div>

      <div class="ml-px whitespace-no-wrap">
        <label for="crMin" class="u-visually-hidden">Min CR:</label>
        <base-select
          default-option="Min CR"
          title="Min CR"
          :collection="monsterCRs"
          :selected-if="matchesCurrent(crMin)"
          name="crMin"
          v-model="crMin"
          :disabled-if="disableAboveMax"
          data-test="monsterCrMin"
        />
      </div>

      <div class="ml-px whitespace-no-wrap">
        <label for="crMax" class="u-visually-hidden">Max CR:</label>
        <base-select
          default-option="Max CR"
          :collection="monsterCRs"
          :selected-if="matchesCurrent(crMax)"
          name="crMax"
          v-model="crMax"
          :disabled-if="disableBelowMin"
          data-test="monsterCrMax"
          title="Max CR"
        />
      </div>

      <button
        class="max-sm:absolute max-sm:l-full max-sm:t-half max-sm:-y-half sm:ml-px sm:bg-tint-less sm:hover:bg-tint cursor-default flex hover:text-accent p-3 text-accent-40 text-xl"
        type="reset"
        aria-label="Reset filters"
        title="Reset filters"
        @click="reset"
      >
        <icon data-id="reroll" class="fill-current" />
      </button>
    </div>
  </form>
</template>

<script>
import BaseField from '@/components/BaseField'
import BaseSelect from '@/components/BaseSelect'
import { mapGetters, mapState, mapMutations } from 'vuex'
import { startCase } from 'lodash-es'

export default {
  name: `BestiarySearchForm`,

  components: {
    BaseSelect,
    BaseField,
  },

  computed: {
    ...mapGetters(`battles`, [`battle`]),
    ...mapGetters(`bestiary`, [
      `crMaxIndex`,
      `crMinIndex`,
      `monsterCRs`,
      `monsterTypes`,
      `url`,
    ]),

    ...mapState(`bestiary`, [`search`]),

    term: {
      get() {
        return this.search.term
      },
      set(term) {
        this.update({ term })
      },
    },

    type: {
      get() {
        return this.search.type
      },
      set(type) {
        this.update({ type })
      },
    },

    crMin: {
      get() {
        return this.search.crMin
      },
      set(crMin) {
        this.update({ crMin })
      },
    },

    crMax: {
      get() {
        return this.search.crMax
      },
      set(crMax) {
        this.update({ crMax })
      },
    },
  },

  methods: {
    startCase,
    ...mapMutations(`bestiary`, {
      update: `doUpdateSearch`,
      reset: `doReset`,
    }),

    disableBelowMin(index) {
      return this.crMinIndex > -1 && index < this.crMinIndex
    },
    disableAboveMax(index) {
      return this.crMaxIndex > -1 && index > this.crMaxIndex
    },
    matchesCurrent(match) {
      return item => item.toLowerCase() === match
    },
  },
}
</script>
